<template>
  <div class="home-container">
    <!-- 整体布局 -->
    <el-container>
      <!-- 侧边栏 -->
      <el-aside :width="isCollapsed ? '64px' : '220px'">
        <div class="logo-area">
          <div class="system-logo">
            <i class="el-icon-setting"></i>
            <span v-if="!isCollapsed">客户管理系统</span>
          </div>
        </div>
        
         <el-menu 
          :default-active="activeMenu" 
          background-color="#001529" 
          text-color="#b7bdc3"
          active-text-color="#1890ff"
          :collapse="isCollapsed"
          :collapse-transition="false"
          class="side-menu"
          @select="handleMenuSelect"
        >
          <el-menu-item index="customer">
            <i class="el-icon-user"></i>
            <span slot="title">客户管理</span>
          </el-menu-item>
          <el-menu-item index="store">
            <i class="el-icon-location"></i>
            <span slot="title">门店管理</span>
          </el-menu-item>
        </el-menu>
        
        <!-- 折叠按钮 -->
        <div class="collapse-bottom" @click="toggleCollapse">
          <i :class="isCollapsed ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
          <span v-if="!isCollapsed">收起菜单</span>
        </div>
      </el-aside>
      
      <!-- 主内容区 -->
      <el-container>
        <el-header class="main-header">
          <div class="header-title">
            <h2><i :class="activeMenu === 'customer' ? 'el-icon-s-custom' : 'el-icon-shop'"></i> {{ activeMenu === 'customer' ? '客户管理' : '门店管理' }}</h2>
          </div>
          <div class="user-area">
            <el-dropdown trigger="click" @command="handleCommand">
              <span class="user-avatar">
                <el-avatar :size="36" :src="adminAvatar" />
                <span class="user-name">{{ user.name }}</span>
                <i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item><i class="el-icon-user"></i>个人中心</el-dropdown-item>
                <el-dropdown-item><i class="el-icon-setting"></i>系统设置</el-dropdown-item>
                <el-dropdown-item divided command="logout"><i class="el-icon-switch-button"></i>退出登录</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
        </el-header>
        
        <el-main class="main-content">
          <CustomerManagement v-if="activeMenu === 'customer'" />
          <StoreManagement v-if="activeMenu === 'store'" />
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>

<script>
import CustomerManagement from '../components/CustomerManagement'
import StoreManagement from '../components/StoreManagement'
import defaultAvatar from '@/assets/default_user.png'
import adminAvatar from '@/assets/home.jpg'

export default {
  name: 'HomePage',
  components: {
    CustomerManagement,
    StoreManagement
  },
  data() {
    return {
      isCollapsed: false,
      activeMenu: 'customer',
      adminAvatar,
      user: {
        name: '管理员'
      }
    }
  },
  methods: {
    toggleCollapse() {
      this.isCollapsed = !this.isCollapsed;
    },
    handleMenuSelect(index) {
      this.activeMenu = index;
    },
    handleCommand(command) {
      switch(command) {
        case 'logout':
          this.handleLogout();
          break;
        case 'profile':
          // 处理个人中心
          break;
        case 'settings':
          // 处理系统设置
          break;
      }
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('token')
        this.$router.push('/login')
        this.$message.success('已退出登录')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.home-container {
  height: 100vh;
  overflow: hidden;
  background-color: #f0f2f5;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", Arial, sans-serif;
}

.home-container .el-container {
  height: 100%;
}

/* 侧边栏样式 */
.home-container .el-aside {
  background-color: #001529;
  transition: width 0.3s;
  display: flex;
  flex-direction: column;
  position: relative;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}

.home-container .el-aside .logo-area {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 60px;
  padding: 0 16px;
  color: white;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.home-container .el-aside .logo-area .system-logo {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: 600;
}

.home-container .el-aside .logo-area .system-logo i {
  font-size: 24px;
  margin-right: 8px;
}

/* 折叠按钮样式 */
.home-container .el-aside .collapse-bottom {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 15px 0;
  background-color: rgba(0, 0, 0, 0.2);
  text-align: center;
  cursor: pointer;
  color: #b7bdc3;
  transition: all 0.3s;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.home-container .el-aside .collapse-bottom:hover {
  background-color: rgba(0, 0, 0, 0.3);
  color: #1890ff;
}

.home-container .el-aside .side-menu {
  flex: 1;
  border: none;
  margin-bottom: 48px;
}

/* 主内容区样式 */
.home-container .el-header.main-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;
  padding: 0 24px;
  background-color: white;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.home-container .el-header.main-header .header-title h2 {
  margin: 0;
  font-size: 18px;
  color: #333;
}

.home-container .el-header.main-header .header-title h2 i {
  margin-right: 8px;
  color: #1890ff;
}

.home-container .el-header.main-header .user-area {
  display: flex;
  align-items: center;
}

.home-container .el-header.main-header .user-area .user-avatar {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.home-container .el-header.main-header .user-area .user-avatar .el-avatar {
  margin-right: 8px;
}

.home-container .el-header.main-header .user-area .user-avatar .user-name {
  font-weight: 500;
  margin-right: 4px;
}

.home-container .el-main.main-content {
  padding: 20px;
  overflow: auto;
  background-color: #f0f2f5;
}
</style>